// extracted by mini-css-extract-plugin
module.exports = {"link":"BorderedLink_link__hSnWM","active":"BorderedLink_active__JY9C_"};